var createHtmlRenderState = function () { return ({
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {},
}); };

export { createHtmlRenderState };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/render/html/utils/create-render-state.js
// module id = 61
// module chunks = 0